import Vue from "vue";
import "@/utils/localstorage";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as filters from "./filters";
import i18n from "./lang"; // Internationalization
import "@/styles/common.css"; // global css
import Mint from "mint-ui";
import "mint-ui/lib/style.css";
import '@/plugins/firebase'
import trendContent from "./views/trend/Trend";

Vue.component("trend-content", trendContent);

Vue.use(Mint);

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

window.getLocalCoinImg = function (coinName) {
  var localimg = [
    { url: require("./assets/img/coin/UNKNOWN.png"), name: "UNKNOWN" },
    { url: require("./assets/img/coin/ADA.png"), name: "ADA" },
    { url: require("./assets/img/coin/AISI.png"), name: "AISI" },
    { url: require("./assets/img/coin/BCH.png"), name: "BCH" },
    { url: require("./assets/img/coin/BNB.png"), name: "BNB" },
    { url: require("./assets/img/coin/BTC.png"), name: "BTC" },
    { url: require("./assets/img/coin/EOS.png"), name: "EOS" },
    { url: require("./assets/img/coin/ETC.png"), name: "ETC" },
    { url: require("./assets/img/coin/ETH.png"), name: "ETH" },
    { url: require("./assets/img/coin/HT.png"), name: "HT" },
    { url: require("./assets/img/coin/IOTA.png"), name: "IOTA" },
    { url: require("./assets/img/coin/LTC.png"), name: "LTC" },
    { url: require("./assets/img/coin/USDT.png"), name: "USDT" },
    { url: require("./assets/img/coin/XRP.png"), name: "XRP" },
  ];
  for (var i = 0; i < localimg.length; i++) {
    if (localimg[i].name == coinName) {
      return localimg[i].url;
    }
  }
  return localimg[0].url;
};

Vue.config.productionTip = false;
window.getvalueFromApp = function (val) {
  console.log(val);
};
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
